/**
 * Safe JSON-LD component that escapes </script> sequences in stringified JSON.
 * Prevents XSS via JSON-LD injection (PERF-16).
 */
export function JsonLd({ json }: { json: string }) {
  // Escape </script> sequences that could break out of the script tag
  const safeJson = json.replace(/<\/(script)/gi, "<\\/$1");

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJson }}
    />
  );
}
